import { useMenuStore } from '../stores/menuStore'
import { getColorVariants, getBusinessColor } from '../utils/colorUtils'

/**
 * Hook to get business color and its variants
 */
export function useBusinessColor() {
  const { menu } = useMenuStore()
  const businessColor = menu?.business?.color || '#1E293B'
  const color = getBusinessColor(businessColor)
  const variants = getColorVariants(color)

  return {
    color,
    ...variants,
  }
}

